import {Injectable} from "@angular/core";
import {CanDeactivate} from "@angular/router";
import {MyinfoEditComponent} from "../../member/myinfo-edit/myinfo-edit.component";


@Injectable()
export class MyinfoCanDeactivate implements CanDeactivate<MyinfoEditComponent> {

  canDeactivate(component: MyinfoEditComponent): boolean {
    return component.onCanDeactivate();
  }

}



// WEBPACK FOOTER //
// ./src/app/service/member/myinfo-can-deactivate.service.ts